module.exports = __webpack_public_path__ + "img/mobilePhoneRed.bb9cec6b.png";